import script from "./Item.vue?vue&type=script&lang=ts&setup=true"
export * from "./Item.vue?vue&type=script&lang=ts&setup=true"

import "./Item.vue?vue&type=style&index=0&id=05be8e67&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05be8e67"]])

export default __exports__